<template>
  <div class="menu-item-r">
    <div class="v-personal-wrap bl-container">
      <router-view :key="$route.fullPath"></router-view>
    </div>
  </div>
</template>
<script>
export default {
  name: 'personalCenter',
  data() {
    return {}
  },
  methods: {},
  computed: {},
  created() {}
}
</script>
<style lang="stylus" scoped>
.v-personal-wrap{
    width:100%;
    max-width:$container-width;
    margin: 30px auto;
    background:$color-white;
}
</style>
